export const CREDENTIALS_SETUP = "CREDENTIALS_SETUP";
export const CREATE_LOBBY = "CREATE_LOBBY";
